<template>
    <va-create-layout>
        <SellerReviewEnrollmentPaymentEventFee-form
            :title="title"
            :item="item"
        ></SellerReviewEnrollmentPaymentEventFee-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
